<template>
  <metainfo>
    <template v-slot:title="{ content }">
      {{ content ? `${content} - ${metaTitle}` : metaTitle }}
    </template>
  </metainfo>
  <Layout>
    <RouterView />
  </Layout>
</template>

<script setup lang="ts">
import { useStepStore, useFormTargetStore } from "@/stores";
import { message } from "ant-design-vue";
import { provide } from "vue";
import { RouterView } from "vue-router";
import Layout from "./layouts/Layout.vue";
// import { setTimeout } from "timers/promises";

message.config({
  duration: 5,
});

const stepStore = useStepStore();
const formTargetStore = useFormTargetStore();

provide("stepStore", stepStore);
provide("formTargetStore", formTargetStore);

const metaTitle = "สรรหาแต่งตั้ง";

// setTimeout(() => {
  // console.log("Delayed for 1 second.");
  const nonce = 'randomString123';
  document.querySelectorAll('style').forEach(style => {
    style.setAttribute('nonce', nonce);
  });
// }, 1000);



</script>
